"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaArchives = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../render/CardRenderer");
var MediaArchives = (function (_super) {
    __extends(MediaArchives, _super);
    function MediaArchives() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MEDIA_ARCHIVES,
            tags: [Tags_1.Tags.EARTH],
            cost: 8,
            metadata: {
                cardNumber: '107',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(1).slash().event().played.any;
                }),
                description: 'Gain 1 M€ for each event EVER PLAYED by all players.',
            },
        }) || this;
    }
    MediaArchives.prototype.play = function (player) {
        var allPlayedEvents = player.game.getPlayers().map(function (player) { return player.getPlayedEventsCount(); }).reduce(function (a, c) { return a + c; }, 0);
        player.addResource(Resources_1.Resources.MEGACREDITS, allPlayedEvents, { log: true });
        return undefined;
    };
    return MediaArchives;
}(Card_1.Card));
exports.MediaArchives = MediaArchives;
//# sourceMappingURL=MediaArchives.js.map